//Modules 
import io from 'socket.io-client';

const Socket = (query_object) => {
    let server = process.env.REACT_APP_API_URL?.split('/api')[0];
    
    console.log('[SOCKET URL]', server); // Debug
    
    const socket = io(server, {
        path: '/socket.io', // explícito
        transports: ['websocket', 'polling'],
        query: query_object
    });

    socket.on('connect_error', (err) => {
        console.error('Socket connect error:', err
        );
    });

    return socket;
}

export default Socket;
